import React, { Component } from "react"
import { connect } from "react-redux"
import * as strings from "../../strings"
import Yup from "../../lib/Yup"
import _ from "lodash"
import * as FormikComponents from "../../components/FormikComponents"
import FormikDialog from "../../components/FormikDialog"
import Spacer from "../../components/Spacer"
import { toastr } from "react-redux-toastr"
import { withActions } from "../../utils"
import styled from "styled-components"

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &> *:nth-child(odd) {
    flex: 1;
  }
`

const BILLING_ORDER_SCHEMA = Yup.object().shape( {
  billingPhase: Yup.string().nullable(),
  clientName: Yup.string().nullable(),
  debtPhase: Yup.string().nullable(),
  segment: Yup.string().nullable(),
  invoiceDate: Yup.date().nullable(),
  invoiceNumber: Yup.string().nullable(),
  value: Yup.number().nullable(),
} )

class BillingOrderDialog extends Component {
  props: {
    billingOrder: any,
    idBillingOrder: number,
    clients: [],
    visible: boolean,
    hideDialog: Function,
    actions: any,
  }

  save = billingOrder => this.props.actions.updateBillingOrder( billingOrder )
    .then( () => toastr.success( strings.billingOrders.billingOrderUpdated ) )
    .then( () => this.props.hideDialog() )
    .catch( () => toastr.error( strings.billingOrders.errorUpdatingBillingOrder ) )

  render () {
    const { visible, billingOrder, clients, hideDialog } = this.props

    const billingPhaseSource = _.entries( strings.BillingPhaseTranslation )
      .map( ( [ value, key ] ) => ( { label: key, value } ) )

    const debtPhaseSource = _.entries( strings.DebtPhaseTranslation )
      .map( ( [ value, key ] ) => ( { label: key, value } ) )

    const clientSource = _.chain( clients )
      .map( ( { name } ) => ( { value: name, label: name } ) )
      .orderBy( "label" )
      .value()

    return (
      <FormikDialog
        title={strings.billingOrders.billingOrder}
        yupSchema={BILLING_ORDER_SCHEMA}
        initialValues={billingOrder}
        visible={visible}

        onCancel={hideDialog}
        onSave={this.save}
        extraActions={{
          [ "Relatório" ]: ( f ) => {
            this.props.actions.billingOrderExpensesReport( f.values.id )
          },
        }}
      >
        <Row>
          <FormikComponents.Dropdown
            label={strings.generalStrings.billingPhase}
            source={billingPhaseSource}
            name="billingPhase"
            disabled
          />
          <Spacer size={1} />
          <FormikComponents.Dropdown
            label={strings.processes.processPhase}
            source={debtPhaseSource}
            name="debtPhase"
            disabled
          />
        </Row>
        <FormikComponents.Dropdown
          label={strings.generalStrings.company}
          source={clientSource}
          name="clientName"
          disabled
        />
        <FormikComponents.Input
          label={strings.invoices.invoiceNumber}
          name="invoiceNumber"
        />
        <Row>
          <FormikComponents.Input
            label={strings.generalStrings.invoiceValue}
            name="value"
            type="number"
            step="0.01"
          />
          <Spacer size={1} />
          <FormikComponents.DatePicker
            label={strings.generalStrings.date}
            name="invoiceDate"
          />
        </Row>
        <Row>
          <FormikComponents.Dropdown
            label={strings.generalStrings.segment}
            source={[ {
              value: null,
              label: "Sem segmento",
            }, {
              value: "B2B",
              label: "B2B",
            }, {
              value: "B2C",
              label: "B2C",
            } ]}
            name="segment"
          />
        </Row>
      </FormikDialog>
    )
  }
}

export default connect( ( store, props ) => ( {
  billingOrder: _.find( store.billingOrders, { id: props.idBillingOrder } ),
  clients: _.get( store, "suggestions.clients", [] ),
} ) )( withActions( BillingOrderDialog ) )



// WEBPACK FOOTER //
// ./src/views/BillingOrders/BillingOrderDialog.jsx